export default "__VITE_PUBLIC_ASSET__829a8753__"